import { ImageSize } from '../../cms/blocks/types.gen'

export type ExtraImages =
  

// Van oord
// Grid Block
| "1440x720"
|  "720x360"
|  "560x280"

// Page header
| "2720x1360"  
| "1360x680" 
| "680x340"

//Media
| '720w'
| '1440w'
| '2880w'

// Quote 
| '320x320'
| '640x640'

// Double images + text 
| '1600x1200' 
| '800x600' 
| '400x300'
| '1100x1100' 
| '555x555' 
| '280x280'

// Gallery
| '580x580'
| '640x640'
| '1280x1280'
| '1920x1920'

// Sustainability Development block
| '175x175'
| '345x345'
| '690x690'

// Other key projects block
| '480x300'
| '960x600'
| '1440x900'

// OLD PROJECT - Needed to not break code but unused 
| 'full'
| '640w'
| '1280w'
| '1920w'

export type extra_images = ExtraImages

// ----- VAN OORD

export const linkgridblock_src: () => ImageSize = () => '560x280'
export const linkgridblock_srcset: () => [ImageSize, string][] = () => [
  ['560x280', '560w'],
  ['720x360', '720w'],
  ['1440x720', '1440w'],
]

export const pageheader_src: () => ImageSize = () => '680x340'
export const pageheader_srcset: () => [ImageSize, string][] = () => [
  ['680x340', '680w'],
  ['1360x680', '1360w'],
  ['2720x1360', '2720w']
]

export const mediablock_src: () => ImageSize = () => '720w'
export const mediablock_srcset: () => [ImageSize, string][] = () => [
  ['720w', '720w'],
  ['1440w', '1440w'],
  ['2880w', '2880w']
]

export const quoteblock_src: () => ImageSize = () => '320x320'
export const quoteblock_srcset: () => [ImageSize, string][] = () => [
  ['320x320', '320w'],
  ['640x640', '640w']
]

export const doubletextimagefirstblock_src: () => ImageSize = () => '400x300'
export const doubletextimagefirstblock_srcset: () => [ImageSize, string][] = () => [
  ['400x300', '400w'],
  ['800x600', '800w'],
  ['1600x1200', '1600w']
]

export const doubletextimagesecondblock_src: () => ImageSize = () => '280x280'
export const doubletextimagesecondblock_srcset: () => [ImageSize, string][] = () => [
  ['280x280', '280w'],
  ['555x555', '555w'],
  ['1100x1100', '1100w']
]

export const gallery_src: () => ImageSize = () => '580x580'
export const gallery_srcset: () => [ImageSize, string][] = () => [
  ['580x580', '580w'],
  ['640x640', '640w'],
  ['1280x1280', '1280w'],
  ['1920x1920', '1920w']
]

export const textimageblock_src: () => ImageSize = () => '720w'
export const textimageblock_srcset: () => [ImageSize, string][] = () => [
  ['720w', '720w'],
  ['1440w', '1440w'],
]

export const developmentblock_src: () => ImageSize = () => '175x175'
export const developmentblock_srcset: () => [ImageSize, string][] = () => [
  ['175x175', '175w'],
  ['345x345', '345w'],
  ['690x690', '690w']
]

export const otherkeyprojectblock_src: () => ImageSize = () => '480x300'
export const otherkeyprojectblock_srcset: () => [ImageSize, string][] = () => [
  ['480x300', '480w'],
  ['960x600', '960w'],
  ['1440x900', '1440w']
]


// // ----- Needed to not break code but unused 

export const get_default_data_src: () => ImageSize = () => 'full'
export const get_default_data_srcset: () => [ImageSize, string][] = () => [
  ['full', '1440w']
]